import React, { Component } from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "reactstrap";

const Feedback = () => {
  const sendFeedback = (e) => {
    e.preventDefault();
    window.location.href = "mailto:info@biologis.eu";
  };

  return (
    <>
      <h1>
        <FormattedMessage id="feedback.title" />
      </h1>
      <Button color="primary" onClick={sendFeedback}>
        <FormattedMessage id="feedback.openModalButton" />
      </Button>
    </>
  );
};

export default Feedback;
